import React, { Fragment } from 'react';
import { SectionGridSkeleton } from '.';
import { Grid } from '../../../../../components/ATS/Grid/Grid';
import Spinner from '../../../../../components/Spinner';
import { useInfiniteSectionItems } from '../../../../../queries/ats/layout/queries';
import { Layout } from '../../../../../queries/ats/layout/types';
import { EmptyPage } from '../../../page/empty-page';
import css from './section-grid.module.scss';

interface SectionGridProps {
  view: Layout.SectionView;
  data: Layout.SectionItem[];
}

const GRID_TAKE = 50;

export function PaginatedSectionGrid({ view, data }: SectionGridProps) {
  const {
    data: items,
    isLoading,
    isFetching,
    fetchNextPage,
  } = useInfiniteSectionItems({ link: view.link, take: GRID_TAKE, initialData: data });

  if (isLoading) {
    return <SectionGridSkeleton view={view} />;
  }

  if (items === undefined) {
    throw new Error('Data should be defined');
  }

  const flattenedItems = items.pages.flat();

  if (flattenedItems.length === 0) {
    return <EmptyPage label={view.label} />;
  }

  return (
    <Fragment>
      <Grid className={css.grid} onScrollBottom={fetchNextPage} pattern={view.style.pattern} items={flattenedItems} />
      {isFetching ?? <Spinner wrapInContainer />}
    </Fragment>
  );
}
